define('shared/initializer/form/newHouseAdapters/mixins/MemberCreatable',[
    '$',
    'Promise',
    'shared/page/wcmmode',
    'shared/util/state',
    'shared/util/checkout/member',
    'shared/remote/member/get',
    'shared/remote/member/create',
    'shared/my/efid',
    'shared/remote/efid/get',
    './SubscriptionsSavable',
    '../util/getReferredPayload',
    '../util/getTrackingPayload',
    'shared/page/eTag',
    'shared/util/path',
    'shared/util/hub',
    'shared/util/state/adapters/persistent'
],
function ( 
    $,
    Promise,
    getWCMMode,
    state,
    memberUtil,
    getMember,
    createMember,
    myEFID,
    getEFIDDetails,
    SubscriptionsSavable,
    getReferredPayload,
    getTrackingPayload,
    getETag,
    pathUtil,
    hub,
    persistentAdapter
) {
    'use strict';

    var MODULE_NAME = 'MemberCreatable:';
    var memberCreatingPromise;
    var STATE_KEY_ENABLE_NEW_HOUSE = 'persistent.new_house_reg_enabled';

    function getFieldValue(fieldName) {
        var me = this;
        return me.items.get(fieldName) && me.items.get(fieldName).$el.val();
    }

    function Ctor() {

    }

    function createWithMemberFormData() {
        var me = this;
        var efid;
        var options;

        return Promise.resolve()
            .then(function(){
                return myEFID.get();
            })
            .then(function(v){
                return getEFIDDetails(v);
            })
            .then(function(v){
                efid = v;
                return Promise.all([
                    state.get(SubscriptionsSavable.STATE_KEY),
                    getReferredPayload(),
                    getETag(),
                    getTrackingPayload()
                ]);
            })
            .then(function(values){
                var subscriptions = values[0][0];
                var referred = values[1];
                var etag = values[2];
                var tracking = values[3];
                var telephone = getFieldValue.call(me, 'telephone');
                options = {
                    name: efid.name,
                    email: efid.email,
                    subscriptions: subscriptions,
                    referred: referred,
                    etag: etag,
                    tracking: tracking,
                    phones: {
                        telephone: telephone
                    }
                };

                return pathUtil.sub();
            })
            .then(function(subPath){
                if (subPath.indexOf('/buy/') !== 0) {
                    options.lead = options.lead || {};
                    options.lead.type = 'os';
                }

                return createMember(options);
            });
    }

    Ctor.STATE_KEY_ENABLE_NEW_HOUSE = STATE_KEY_ENABLE_NEW_HOUSE;

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        // no need to return here as debugging code 
        // shouldn't block the pageload
        state.adapters.add(persistentAdapter)
            .then(function(){
                return hub.get('/debuglet/settings');
            })
            .then(function(settings){
                settings['Allow NH Reg'] = {
                    getValue: function() {
                        return state
                            .get(STATE_KEY_ENABLE_NEW_HOUSE)
                            .then(function(values){
                                return values[0] && values[0].value || false;
                            });
                    },
                    setValue: function(value) {
                        return state
                            .push(STATE_KEY_ENABLE_NEW_HOUSE, {
                                value: value
                            });
                    }
                };
            });

    };

    p.doSubmit = function(data){
        var me = this;
        if(memberUtil.isUpdatingMemberInfo()){
            return Promise.resolve()
                .then(function() {
                    return data;
                });
        }

        return Promise.resolve()
            .then(function(){
                return getWCMMode();
            })
            .then(function(wcmmode){
                if (wcmmode === 'edit') {
                    return Promise.resolve();
                }
                else if (memberCreatingPromise) {
                    return memberCreatingPromise;
                }
                else {
                    memberCreatingPromise = Promise.resolve()
                        .then(function(){
                            return getMember();
                        })
                        .then(function(member){
                            if (member) {
                                console.log(MODULE_NAME, 'Member was created, so skip it');
                                return;
                            }

                            console.log(MODULE_NAME, 'Member hasn\'t created, go ahead to create it.');
                            return createWithMemberFormData.call(me);
                        })
                        .then(function(){
                            return data;
                        });
                    return memberCreatingPromise;
                }
            });
    };

    return Ctor;
});
